import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "logs-view" }
const _hoisted_2 = { class: "detail-method-block" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "row"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "pb-2 pt-4 col-12",
  style: {"text-align":"center"}
}, "Нет данных", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 0,
  class: "row mt-2 justify-content-center"
}
const _hoisted_15 = {
  key: 1,
  class: "row mt-2 justify-content-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tirscript3_button = _resolveComponent("tirscript3-button")!
  const _component_tirscript3_loading = _resolveComponent("tirscript3-loading")!
  const _component_ItemDetale = _resolveComponent("ItemDetale")!
  const _component_page = _resolveComponent("page")!

  return (_openBlock(), _createBlock(_component_page, {
    name: 'Детальная страница ' + _ctx.getTitle() + ' Http логов',
    selectSource: false
  }, {
    default: _withCtx((slotProps) => [
      _createVNode(_component_tirscript3_button, {
        style: {"width":"100px"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Назад")
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_tirscript3_loading, { loading: _ctx.isLoading }, null, 8, ["loading"]),
        _createElementVNode("div", _hoisted_2, [
          (_ctx.item)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_ItemDetale, {
                  item: { Text: 'RequestId / SessionToken', Value: _ctx.requestId }
                }, {
                  title: _withCtx(() => [
                    _createTextVNode("RequestId "),
                    _hoisted_3,
                    _createTextVNode(" SessionToken ")
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(_ctx.item.RequestId), 1),
                    _hoisted_4,
                    _createTextVNode(_toDisplayString(_ctx.item.SessionToken), 1)
                  ]),
                  _: 1
                }, 8, ["item"]),
                (_ctx.item?.DateEnd)
                  ? (_openBlock(), _createBlock(_component_ItemDetale, {
                      key: 0,
                      item: { Text: 'DateStart / DateEnd', Value: _ctx.item.DateStart }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$filters.DateFormat(_ctx.item.DateStart)) + " / " + _toDisplayString((_ctx.item.DateEnd, _ctx.$filters.DateFormat(_ctx.item.DateEnd))), 1)
                      ]),
                      _: 1
                    }, 8, ["item"]))
                  : (_openBlock(), _createBlock(_component_ItemDetale, {
                      key: 1,
                      item: { Text: 'DateCreate', Value: _ctx.item.DateStart }
                    }, null, 8, ["item"])),
                _createVNode(_component_ItemDetale, {
                  item: {
                Text: 'ProjectName / ServerName / InstanceName(ProjectId)',
                Value: _ctx.item.ProjectName,
              }
                }, {
                  title: _withCtx(() => [
                    _createTextVNode(" ProjectName /"),
                    _hoisted_5,
                    _createTextVNode(" ServerName /"),
                    _hoisted_6,
                    _createTextVNode(" InstanceName(ProjectId) ")
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(_ctx.item.ProjectName) + " " + _toDisplayString(_ctx.item.ServerName) + " " + _toDisplayString((_ctx.item as any)?.InstanceName) + " (" + _toDisplayString(_ctx.item.ProjectLogGroupId) + ") ", 1)
                  ]),
                  _: 1
                }, 8, ["item"]),
                _createVNode(_component_ItemDetale, {
                  item: {
                Text: 'RequestLength / ResponseLength / ms',
                Value: _ctx.item.RequestLength,
              }
                }, {
                  title: _withCtx(() => [
                    _createTextVNode("RequestLength "),
                    _hoisted_7,
                    _createTextVNode(" ResponseLength "),
                    _hoisted_8,
                    _createTextVNode(" ms ")
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(_ctx.item.RequestLength), 1),
                    _hoisted_9,
                    _createTextVNode(_toDisplayString(_ctx.item.ResponseLength) + " ", 1),
                    _hoisted_10,
                    _createTextVNode(" " + _toDisplayString(_ctx.item.DateEnd ? _ctx.$filters.IntervalMs(_ctx.item.DateStart, _ctx.item.DateEnd) : ""), 1)
                  ]),
                  _: 1
                }, 8, ["item"]),
                _createVNode(_component_ItemDetale, {
                  item: { Text: 'Level', Value: _ctx.item.Level }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(`${_ctx.getLogLevel(_ctx.item.Level)} (${_ctx.item.Level})`), 1)
                  ]),
                  _: 1
                }, 8, ["item"]),
                _createVNode(_component_ItemDetale, {
                  item: { Text: 'UserId', Value: _ctx.item.UserId }
                }, null, 8, ["item"]),
                _createVNode(_component_ItemDetale, {
                  item: { Text: 'Url', Value: _ctx.item.Url }
                }, null, 8, ["item"]),
                _createVNode(_component_ItemDetale, {
                  item: { Text: 'Ip / UserId', Value: _ctx.item.Ip }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.item.Ip) + " / " + _toDisplayString(_ctx.item.UserId), 1)
                  ]),
                  _: 1
                }, 8, ["item"]),
                _createVNode(_component_ItemDetale, {
                  item: { Text: 'RequestBody', Value: _ctx.item.RequestBody }
                }, null, 8, ["item"]),
                _createVNode(_component_ItemDetale, {
                  item: { Text: 'ResponseBody', Value: _ctx.item.ResponseBody }
                }, null, 8, ["item"]),
                _createVNode(_component_ItemDetale, {
                  item: { Text: 'Message', Value: _ctx.item.Message }
                }, null, 8, ["item"]),
                _createVNode(_component_ItemDetale, {
                  item: { Text: 'Error', Value: _ctx.item.Error }
                }, null, 8, ["item"]),
                _createVNode(_component_ItemDetale, {
                  item: { Text: 'UserAgent', Value: _ctx.item.UserAgent }
                }, null, 8, ["item"]),
                _createVNode(_component_ItemDetale, {
                  item: { Text: 'TimeoutWaitingEndLog', Value: _ctx.item.TimeoutWaitingEndLog }
                }, null, 8, ["item"]),
                _createVNode(_component_ItemDetale, {
                  item: { Text: 'Error', Value: _ctx.item?.Error }
                }, null, 8, ["item"])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        (!_ctx.item && _ctx.isLoading == false)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.error1.isSuccess)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.error1.errorMessage), 1))
        : _createCommentVNode("", true),
      (!_ctx.error2.isSuccess)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.error2.errorMessage), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["name"]))
}